<section *ngIf="!createSurveyFromCourse">
  <app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

  <!-- new ui section  -->
  <div class="container-fluid mb-5" *ngIf="!skelition">
    <div class="row my-5">
      <div class="col-lg-2 col-md-2 col-sm-12 col-12">
        <div style="visibility: hidden;" class="d-flex align-items-center m-0-7">
          <img class="plus" src="../../../../assets/icones-2025/add.png" alt="loading">
          <h4 class="color-grey mx-2">إضافة</h4>
        </div>
        <div class="option-box" style="color: red">
          <div class="over-flow-y">
            <app-survey-type [tags]="allTags" [currentSurvey]="currentSurvey" [data]="surveys"
              (surveys)="changeCurrentSurvey($event)" (updateDataEvent)="ngOnInit()"></app-survey-type>
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-md-10 col-sm-12 col-12 table-mobile-view">
        <div class="d-flex align-items-center gap-2 mob-my mb-3 flex-wrap">
          <button class="v4-btn-every" *ngIf="types && types.length > 0" (click)="createModal()">
            <i class="pi pi-plus-circle mx-2"></i>{{ "New poll" | translator }}
          </button>
          <button *ngIf="
              hasPermission('SURVEY_TAGS', 'c') ||
              hasPermission('SURVEY_TAGS', 'u') ||
              hasPermission('SURVEY_TAGS', 'd')
            " routerLink="/survey/tags-management" class="v4-btn-border">
            <i class="pi pi-plus-circle mx-2"></i>{{ "Tags Management" | translator }}
          </button>
          <span class="p-input-icon-left" style="max-width: 320px; width: 100%;">
            <i class="pi pi-search"></i>
            <input pInputText class="q-input-white w-100" type="text" [(ngModel)]="surveySearchText"
              placeholder="{{ 'Search survey...' | translator }}" />
          </span>
        </div>
        <div class="option-box-2">
          <div class="outer-wrapper w-100">
            <div class="table-wrapper w-100">
              <table class="w-100">
                <thead>
                  <tr class="mob-trr" *ngIf="selectedSurveys.length == 0; else editHeader">
                    <th>
                      <div class="d-flex align-items-center">
                        <p-checkbox [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" /> -->
                      </div>
                    </th>
                    <th class="table-row-mob-width">
                      {{ "Survey name" | translator }}
                    </th>
                    <th class="table-row-mob-width-name">
                      {{ "Created By" | translator }}
                    </th>
                    <th>{{ "Created" | translator }}</th>
                    <th>{{ "Modified" | translator }}</th>
                    <th>{{ "Start Date" | translator }}</th>
                    <th>{{ "End Date" | translator }}</th>
                    <th>{{ "the condition" | translator }}</th>
                    <th>{{ "Responses" | translator }}</th>
                    <th>{{ "Actions" | translator }}</th>
                  </tr>
                  <br />
                  <ng-template #editHeader>
                    <tr class="mob-trr">
                      <th>
                        <p-checkbox [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="checkboxValue" (ngModelChange)="markAll()" /> -->
                      </th>
                      <th class="table-row-mob-width d-flex flex-row gap-3 align-items-center">
                        <span>{{ "selected" | translator }}
                          {{ selectedSurveys.length }}</span>
                        <p-button (onClick)="
                            surveyActionCall({ action: 'Delete', bulk: true })
                          " styleClass="p-button-text" icon="pi pi-trash"
                          label="{{ 'Delete' | translator }}"></p-button>
                      </th>
                    </tr>
                  </ng-template>
                </thead>
                <tbody *ngIf="currentSurvey">
                  <tr *ngFor="let survey of filteredSurveys; let i = index">
                    <td data-label="factor">
                      <div class="d-flex align-items-center">
                        <p-checkbox [(ngModel)]="survey.selected"
                        (ngModelChange)="selectSurvey(survey, $event)" [binary]="true" inputId="binary"></p-checkbox>
                        <!-- <input type="checkbox" [(ngModel)]="survey.selected"
                          (ngModelChange)="selectSurvey(survey, $event)" /> -->
                      </div>
                    </td>
                    <td data-label="factor"
                      class="table-row-mob-width show-count d-flex flex-row gap-2 align-items-center"
                      style="color: var(--color-text-grey);">
                      <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'Copy' | translator }}" (onClick)="setCloneQestions(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-copy"></p-button>
                      <p-button class="v4-ui" tooltipPosition="top" pTooltip="{{ 'results' | translator }}" (onClick)="openResultsPage(survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-chart-bar"></p-button>
                          <span routerLink="/survey/add-question/{{ survey._id }}" [queryParams]="{ TypeId: TypeId }"
                            class="align-self-center" style="font-size: var(--font-size-14)" role="button">{{ survey.name
                            }}</span>
                          <span class="question-count m-r-2" style="color: var(--color-dark-blue-text)">Questions {{
                            survey.questions.length }}</span>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getName(survey?.createdBy?.name) }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ survey.createdAt | date }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ survey.updatedAt | date }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getTransformedDate(survey.startDate) }}</div>
                    </td>
                    <td data-label="factor">
                      <div class="table-data">{{ getTransformedDate(survey.endDate) }}</div>
                    </td>
                    <td data-label="factor">
                      <select class="tab-drop" name="{{ survey.status }}" id="{{ survey.status }}"
                        [(ngModel)]="survey.status" (ngModelChange)="updateSurveyData(survey)">
                        <option *ngFor="let option of statusOptions" [value]="option">
                          {{ getStatusArabic(option) }}
                        </option>
                      </select>
                    </td>
                    <td data-label="factor" [style]="{ 'text-align': 'center' }">{{ survey.attempts }}</td>
                    <td data-label="factor">
                      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                      <p-button class="v4-ui" (onClick)="openSurveyMenu(menu, $event, survey)"
                        styleClass="p-button-rounded p-button-text" icon="pi pi-ellipsis-v"></p-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end -->

  <!-- skelition   -->
  <app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>

  <!-- Confirm Modal -->
  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

  <!-- Update Data Modal -->
  <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
    (onHide)="onDialogClose()" [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1000px' }">
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{ "Update survey" | translator }}</span>
    </ng-template>
    <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
      (sendData)="updateSurveyData($event)"></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <!-- Create new Modal -->
  <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
    [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }" (onHide)="onDialogClose()">
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{
        "Create a new survey" | translator
        }}</span>
    </ng-template>
    <app-dynamic-form [questions]="questions" (sendData)="receiveSurveyData($event)"></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </p-dialog>

  <app-footer></app-footer>
</section>

<!-- create survey from course details -->
<section *ngIf="createSurveyFromCourse">
  <app-dynamic-form [questions]="updateModal && updateSurvey._id ? updateQuestions : questions" (sendData)="
      updateModal && updateSurvey._id
        ? updateSurveyData($event)
        : receiveSurveyData($event)
    "></app-dynamic-form>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
</section>